import { Dialog } from '@mui/material';
import { useEffect, useState } from 'react'
import { IoClose } from 'react-icons/io5';
import { IoSettingsSharp } from "react-icons/io5";
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

const SettingModal = ({ displayModal, setDisplayModal }) => {
    const { t } = useTranslation('SettingModal');
    const [currentLang, setCurrentLang] = useState(localStorage.getItem('lang') || 'fr');

    useEffect(() => {
        if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', 'fr');
        }
    }, []);
    const handleclose = () => {
        setDisplayModal(false);
    }
    const handleEnglish = () => {
        localStorage.setItem('lang', 'en');
        setCurrentLang('en');
        i18n.changeLanguage('en');
    }
    const handleFrance = () => {
        localStorage.setItem('lang', 'fr');
        setCurrentLang('fr');
        i18n.changeLanguage('fr');
    }

    return (
        <>
            <Dialog
                open={displayModal}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "260px",
                    },
                }}
            >
                <div className="bg-white p-5 pb-7 flex flex-col  gap-3 rounded-[20px] ">
                    <div className="flex   justify-end items-center  w-full ">
                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                    </div>
                    <div className="w-full flex flex-col items-center text-center gap-1">
                        <span><IoSettingsSharp size={35} fill='#ED3939' /></span>
                        <p className='text-[14px]'>{t("title")}</p>
                        <p className='text-[15px] leading-5'>{t("description")}</p>

                    </div>

                    <div className="flex flex-col gap-1  items-center">
                        <button className={` rounded-lg  h-[42px]  w-full max-w-32 my-1  text-[14px] text-center ${currentLang === 'fr' ? 'bg-[#3686FF] text-white ' : 'bg-[#EDF4FF] text-black'}`} onClick={handleFrance}>{t("frn")}</button>
                        <button className={`rounded-lg   h-[42px]  w-full max-w-32 my-1  text-[14px] text-center ${currentLang === 'en' ? 'bg-[#3686FF] text-white ' : 'bg-[#EDF4FF] text-black'}`} onClick={handleEnglish} >{t("eng")}</button>
                    </div>


                </div>
            </Dialog >
        </>
    )
}

export default SettingModal;
